<div *ngIf="showPresets"
     class="brand-colors mx-n2 mt-n2 mb-2 p-2 border-bottom">
  <div class="d-flex mb-1">
    <p class="small m-0 ml-1 flex-grow-1">
      {{'design.colors.title' | transloco}}
      <a *ngIf="showEditButton"
         [routerLink]="['/organizations', organizationId, 'design']"
         [attr.data-tooltip-text]="'design.colors.edit' | transloco"
         data-tooltip-position="right"
         class="edit-button">
        <fa-icon [icon]="['fas', 'cog']"
                 size="sm"></fa-icon>
      </a>
    </p>
    <button *ngIf="canShowResetButton" type="button"
            class="btn btn-link btn-sm p-0 d-inline-flex align-items-center"
            style="line-height: 1"
            (click)="changeValue(defaultValue)">
      <span class="small text-muted"
            style="font-size: 12px; margin-top: 1px">
        {{'design.colors.reset' | transloco}}
      </span>
    </button>
  </div>
  <div class="color-wrapper pt-1">
    <ng-container  *ngFor="let preset of presets">
      <app-color-circle [color]="preset.value"
                        (select)="writePreset(preset)"
                        [active]="(preset.name | presetExtractName) === (value | presetExtractName)" >
      </app-color-circle>
    </ng-container>
  </div>
</div>

<div class="saturation" *ngIf="hsl && hsv">
  <color-saturation [hsl]="hsl"
                    [hsv]="hsv"
                    (onChange)="rawColorChangedHsva($event); applyColorChange()">
  </color-saturation>
</div>

<div class="controls" *ngIf="hsl">
  <div class="sliders">
    <div class="hue">
      <color-hue [hsl]="hsl"
                 (onChange)="rawColorChangedHsla($event); applyColorChange()">
      </color-hue>
    </div>
  </div>

  <div class="color">
    <app-color-circle [color]="activeBackground"></app-color-circle>
  </div>
</div>

<!--
We used to use the sketch-color control directly from ngx-color but this caused problems in conjunction with quilljs.
When formatting text, quilljs requires the text to be focused. So when you typed a hex code before, quill would grab
the focus and you would type into quill instead before you were even able to finish typing the full hex code.
This is prevented now, by setting the focus back into the respecting input (hex, r, g, b) after the focus is lost.
Also now we no longer have a feedback-loop when entering anything into the inputs. Before, ngx-color tried to parse
the hex code after every keystroke and put the result of that into the input.
-->
<div class="inputs">
  <div class="hex">
    <input #hexInput
           type="text"
           [value]="hex"
           (change)="rawColorChangedHex(hexInput.value)"
           (focusout)="applyColorChange('hex')"
           (keydown.enter)="rawColorChangedHex(hexInput.value); applyColorChange('hex')">
    <span>hex</span>
  </div>
  <div class="r">
    <input #r
           type="number"
           [min]="0"
           [max]="255"
           [value]="rgb.r"
           (change)="rawColorChangedRgb({r: +r.value})"
           (focusout)="applyColorChange('r')"
           (keydown.enter)="rawColorChangedRgb({r: +r.value}); applyColorChange('r')">
    <span>r</span>
  </div>
  <div class="g">
    <input #g
           type="number"
           [min]="0"
           [max]="255"
           [value]="rgb.g"
           (change)="rawColorChangedRgb({g: +g.value})"
           (focusout)="applyColorChange('g')"
           (keydown.enter)="rawColorChangedRgb({g: +g.value}); applyColorChange('g')">
    <span>g</span>
  </div>
  <div class="b">
    <input #b
           type="number"
           [min]="0"
           [max]="255"
           [value]="rgb.b"
           (change)="rawColorChangedRgb({b: +b.value})"
           (focusout)="applyColorChange('b')"
           (keydown.enter)="rawColorChangedRgb({b: +b.value}); applyColorChange('b')">
    <span>b</span>
  </div>
</div>
